import React from 'react'
import Navbar from './Navbar'
import Footer from './Footer'



export default function Layout({ children,active }) {
  return (
    <>
      <div className="min-h-screen">
        <Navbar active={active} />
        <main>{children}</main>
      </div>
      <Footer />
    </>
  );
}
